import React from "react";
import { Link } from "react-router-dom";
import { Headline } from "../headline/Headline";
import Card from "../card/Card";
import "./WorkCasePage.sass";

type WorkCasePageProps = {
  title: string;
  heroImage: string;
  heroAlt: string;
  children: React.ReactNode;
  siteUrl?: string;
  siteLabel?: string;
};

function WorkCasePage({
  title,
  heroImage,
  heroAlt,
  children,
  siteUrl,
  siteLabel = "Website besuchen",
}: WorkCasePageProps) {
  return (
    <main className="work-case">
      <div className="border-bottom">
        <Link to="/work" className="link-back">
          <Headline level="h2">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#fff"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-arrow-left"
              aria-hidden
            >
              <line x1="19" y1="12" x2="5" y2="12" />
              <polyline points="12 19 5 12 12 5" />
            </svg>
            Back to work
          </Headline>
        </Link>
      </div>
      <div className="scrollable cardgrid work-case__grid">
        <Card width="12">
          <Headline level="h3">{title}</Headline>
          <div className="work-case__hero">
            <img src={heroImage} alt={heroAlt} />
          </div>
          <div className="work-case__body">{children}</div>
          {siteUrl ? (
            <p className="work-case__cta">
              <a href={siteUrl} target="_blank" rel="noopener noreferrer">
                {siteLabel} ↗
              </a>
            </p>
          ) : null}
        </Card>
      </div>
    </main>
  );
}

export default WorkCasePage;
